<div class="table-responsive">
  <table class="table table-striped table-hover">
    <thead class="table-light">
      <tr>
        <th>Offer</th>
        <th (click)="sortBy('clicks')" role="button">Clicks <i class="bi" [ngClass]="getSortIcon('clicks')"></i></th>
        <th (click)="sortBy('conversions')" role="button">Conversions <i class="bi" [ngClass]="getSortIcon('conversions')"></i></th>
        <th (click)="sortBy('conversionRate')" role="button">Conversion Rate (%) <i class="bi" [ngClass]="getSortIcon('conversionRate')"></i></th>
        <th (click)="sortBy('revenue')" role="button">Payout <i class="bi" [ngClass]="getSortIcon('revenue')"></i></th>
        <th (click)="sortBy('epc')" role="button">EPC <i class="bi" [ngClass]="getSortIcon('epc')"></i></th>
        <th (click)="sortBy('cpl')" role="button">CPL <i class="bi" [ngClass]="getSortIcon('cpl')"></i></th>
      </tr>
    </thead>
    <tbody>
      @if (!loader.isLoading()) {
        @for (statistic of statistics; track statistic; let last = $last) {
          <tr [class.table-light]="last" [class.border-2]="last">
            <td>
              @if (last) {
                Totals
              }
              @if (!last) {
                {{ statistic }}
              }
            </td>
            <td>{{ statistic.clicks }}</td>
            <td>{{ statistic.conversions ?? 0 }}</td>
            <td>{{ (statistic.conversionRate ?? 0) | percent }}</td>
            <td>{{ (statistic.revenue ?? 0) | money:2:$safeNavigationMigration(statistic.currency?.isoCode) }}</td>
            <td>{{ (statistic.epc ?? 0) | money:2:$safeNavigationMigration(statistic.currency?.isoCode) }}</td>
            <td>{{ (statistic.cpl ?? 0) | money:2:$safeNavigationMigration(statistic.currency?.isoCode) }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
